<template>
  <v-form @submit.prevent="submit">
    <v-card>
      <v-card-text>
        <v-autocomplete
          v-model="form.country"
          :loading="form.processing"
          :disabled="form.processing"
          :error-messages="form.errors.country"
          :label="$t('Country')"
          outlined
          :items="countries"
          item-text="name"
          item-value="code"
          autocomplete="off"
        />

        <captcha
          :site-key="captchaSiteKey"
          @result="handleCaptchaResult"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          type="submit"
          :loading="form.processing"
          :disabled="form.processing || ! form.captcha"
          color="primary"
        >
          {{ $t('Submit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import i18n from '@/plugins/vue-i18n';
import { Link } from '@inertiajs/vue2';
import Layout from '@/components/auth/Layout';
import Captcha from '../../components/shared/Captcha.vue';

export default {
  components: { Captcha },
  layout: (h, page) => h(Layout, {
    props: {
      title: i18n.t('Create a demo account')
    },
    scopedSlots: {
      subtitle: () => {
        const loginLink = h(Link, {
          class: {
            'text-decoration-none': true
          },
          props: {
            href: window.route('login'),
          }
        }, i18n.t('Back to login'));

        return loginLink;
      }
    }
  }, [page]),

  props: {
    countries: {
      type: Array,
      required: true
    },
    captchaSiteKey: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        country: '',
        captcha: ''
      })
    }
  },

  methods: {
    submit() {
      this.form.post(this.route('demo'));
    },

    handleCaptchaResult(token) {
      this.form.captcha = token;
    }
  },
}
</script>